import { useEffect, useState } from "react";
import { api, resolveMediaUrl } from "@/lib/api";

const KEY = "nw_brand_logo_v2";
const DEFAULT_MARK = "/navi-nc-mark.png";   // bundled company icon, used until an admin uploads a different one

/** The company logo uploaded in Admin > Landing > Logo. Last value is cached so it shows instantly. */
export function useBrandLogo() {
  const [src, setSrc] = useState(() => { try { return localStorage.getItem(KEY) || DEFAULT_MARK; } catch { return DEFAULT_MARK; } });
  useEffect(() => {
    let alive = true;
    api.get("/content").then(({ data }) => {
      if (!alive) return;
      const hero = data?.hero || {};
      const custom = resolveMediaUrl(hero.logo_url) || "";
      const url = hero.logo_enabled !== false ? (custom.includes("navi-care-logo.png") ? DEFAULT_MARK : custom || DEFAULT_MARK) : "";
      setSrc(url);
      try { url ? localStorage.setItem(KEY, url) : localStorage.removeItem(KEY); } catch {}
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return src;
}
